import React, { useState } from 'react';

import { BurgerMenu, Dropdown } from './components';

const ExternalIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" width="14" height="14"><path d="M3.75 2h3.5a.75.75 0 0 1 0 1.5h-3.5a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-3.5a.75.75 0 0 1 1.5 0v3.5A1.75 1.75 0 0 1 12.25 14h-8.5A1.75 1.75 0 0 1 2 12.25v-8.5C2 2.784 2.784 2 3.75 2Zm6.854-1h4.146a.25.25 0 0 1 .25.25v4.146a.25.25 0 0 1-.427.177L13.03 4.03 9.28 7.78a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.75-3.75-1.543-1.543A.25.25 0 0 1 10.604 1Z"></path></svg>

const promptCompleter = [
  {
    value: "default",
    label: "Public: MythoMax-L2-13b",
    placeHolder: ""
  }, 
  {
    value: "oobabooga",
    label: "Custom: Oobabooga",
    placeHolder: "https://<PUBLIC-API-ID>.trycloudflare.com/api"
  }, 
  {
    value: "openai",
    label: "Custom: OpenAI Key",
    placeHolder: "sk-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
  },
  // {
  //   value: "koboldai",
  //   label: "KoboldAI",
  //   placeHolder: "Please, insert your KoboldAI"
  // }
];

const promptStrategy = [
  {
    label: "Pygmalion Style",
    value: "pyg"
  },
  {
    label: "W++",
    value: "wpp",
  }, 
  {
    label: "RPBT",
    value: "rpbt",
  },
  {
    label: "SBF",
    value: "sbf",
  },
  {
    label: "Alpaca",
    value: "alpaca",
  },
  {
    label: "Vicuna 1.1",
    value: "vicuna11",
  }
];

function Header({ settings, setSettings, isValid, onUploadClick }) {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const inputPlaceholder = promptCompleter.find(item => item.value === settings.selectedEndpoint)?.placeHolder || "";

  const inputValue = settings.endpoints[settings.selectedEndpoint] || "";
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSettings({
      ...settings,
      endpoints: {
        ...settings.endpoints,
        [settings.selectedEndpoint]: value,
      },
    });
  };

  return (
    <header className="App-header">
      <div className="App-logo">
        <img src="/logo.png" alt="logo" height={50} />
        <span>Miku bots directory</span>
        <button className="App-header-action" onClick={onUploadClick}>
          Upload bot
        </button>
        <a className="App-header-action" href="https://build.miku.gg" target="_blank" rel="noreferrer">
          Build bot {ExternalIcon}
        </a>
        <a className="App-header-action" href="https://docs.miku.gg" target="_blank" rel="noreferrer">
          Documentation {ExternalIcon}
        </a>
      </div>
      {/* <div className="App-burger">
        <BurgerMenu isMenuActive={isMenuActive} setIsMenuActive={setIsMenuActive}/>
        {
          isMenuActive && (
            <div className="burger-menu__container">
              <Dropdown dropDownName="Prompt Completer" items={promptCompleter} value={settings.selectedEndpoint} onChange={(value) => setSettings({
                ...settings,
                selectedEndpoint: value,
              })}/>
              {
                settings.selectedEndpoint !== "default" && (
                  <>
                    <input className="api-input" type="text" placeholder={inputPlaceholder} value={inputValue} onChange={handleInputChange} required/>
                    <a className="input-anchor" href="https://docs.miku.gg/guides/run-live/" target="_blank" rel="noreferrer">How to get this endpoint?</a>
                  </>
                )
              }
              <Dropdown dropDownName="Prompt Strategy" items={promptStrategy} value={settings.strategy} onChange={(value) => setSettings({
                ...settings,
                strategy: value,
              })}/>
            </div>
          )
        }
      </div> */}
    </header>
  );
}

export default Header;
